<template>
  <div v-show="show">
    <b-card title="Tipo dos Processos" header-tag="header" footer-tag="footer">
      <div slot="header" class="row mb-0 align-items-right">
        <div class="col-12 text-right ">
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>

            <toggle-button class="mb-0"
              v-model="form.status"
              :width="70"
              :height="25"
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
          </div>
        </div>
      </div>

      <div class="row">
        <b-form-group class="col-12 col-sm-6"
          label="* Nome"
          label-for="name"
          description="">

          <b-form-input id="name"
            v-model="form.name"
            placeholder="Nome"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('name'),
              'is-valid': submitted && !form.errors.has('name')
            }"
            @input="slugify">
          </b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-sm-6"
          label="Slug"
          label-for="slug"
          description="(Se vazia será gerada uma slug automática)">

          <b-form-input id="slug-input"
            v-model="form.slug"
            :class="{
              'is-invalid': submitted && form.errors.has('slug'),
              'is-valid': submitted && !form.errors.has('slug')
            }"
            @change="userEditedSlug = true">
          </b-form-input>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group class="col-12 col-md-6"
          label="Perfil"
          label-for="role_id">
          <multiselect v-model="selectedRole"
            @select="updateForm('role_id', arguments[0])"
            placeholder="Selecione o perfil"
            :allowEmpty="false"
            :options="roles"
            label="name"
            :showLabels="false"
            track-by="id"
            :class="{
              'is-invalid': submitted && form.errors.has('role_id'),
              'is-valid': submitted && !form.errors.has('role_id')
            }"/>
        </b-form-group>
      </div>
      <slot name="footer"></slot>
    </b-card>
  </div>
</template>

<script>
import slugify from 'slugify'
import { get, set, clone } from 'lodash'
import { resolveHTTP } from '@/services/api'
import { slugifyOptions } from '@/plugins'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      show: true,
      userEditedSlug: false,

      locks: {
        roles: true
      },

      selectedRole: null,
      roles: [],

      empty: {
        name: '',
        slug: '',
        role_id: null,
        status: true
      }
    }
  },

  watch: {
    '$props': {
      handler: function (newProps) {
        if (!get(newProps, 'form.role_id', false)) {
          this.selectedRole = null
        }
      },
      deep: true
    }
  },

  computed: {
    ready () {
      return !(this.locks.roles)
    }
  },

  methods: {
    updateForm (path, value) {
      set(this.form, path, value ? value.id : null)
    },

    slugify () {
      const self = this

      if (this.userEditedSlug) {
        return
      }

      self.show = false
      self.form.slug = slugify(self.form.name, slugifyOptions)

      self.$nextTick(() => {
        self.show = true
      })
    }
  },

  created () {
    const self = this

    resolveHTTP('/system/roles').index({ params: { _onepage: true } })
      .then(function (res) {
        self.roles = res.data.collection
        self.locks.roles = false

        self.selectedRole = self.form.role_id
          ? self.roles.find((o) => o.id === self.form.role_id)
          : null
      })

    if (self.instance.id) {
      self.form.setInitialValues(self.instance)
      self.form.role_id = self.instance.role_id || null
    } else {
      self.form.setInitialValues(this.empty)
      self.form.withData(clone(this.empty))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Bl/ProcessFileType.vue